import { language as esResources } from "./resources/es";
import { language as enResources } from "./resources/en";

const language = {
  es: esResources,
  en: enResources,
};

export default language;
